import { TURKEY_PROVINCE_CENTERS } from './turkeyProvinceCenters';

/** CMS'te bilinen yanlış koordinatlar — madde id → { lat, lng } */
const MAP_ITEM_COORD_OVERRIDES = {
  /** Cumhuriyet Sucukları (Afyon); API'de İstanbul merkezi girilmiş */
  12437: { lat: 38.75727979547636, lng: 30.536640592670434 },
};

const COORD_EPS = 0.0001;

function isProvinceCenterCoord(lat, lng) {
  return TURKEY_PROVINCE_CENTERS.some(
    ([clat, clng]) => Math.abs(clat - lat) < COORD_EPS && Math.abs(clng - lng) < COORD_EPS
  );
}

/** Başlıkta geçen il adına göre il merkezi koordinatı */
function provinceCenterFromTitle(title) {
  if (!title) return null;
  const normalized = title.toLocaleLowerCase('tr');
  const byNameLength = [...TURKEY_PROVINCE_CENTERS].sort((a, b) => b[2].length - a[2].length);

  for (const [lat, lng, name] of byNameLength) {
    const key = name.toLocaleLowerCase('tr');
    if (normalized.includes(key)) return { lat, lng, name };
    if (key === 'afyonkarahisar' && normalized.includes('afyon')) {
      return { lat, lng, name };
    }
  }
  return null;
}

/**
 * Harita API'sinden gelen madde koordinatlarını düzeltir.
 * CMS'te il merkezi varsayılanı veya bilinen hatalı girişler için.
 */
export function normalizeMapItemCoordinates(item) {
  const id = item?.id;
  const override = id != null ? MAP_ITEM_COORD_OVERRIDES[id] : null;
  if (override) {
    return { ...item, lat: override.lat, lng: override.lng };
  }

  const lat = Number.parseFloat(item?.lat);
  const lng = Number.parseFloat(item?.lng);
  if (Number.isNaN(lat) || Number.isNaN(lng)) return item;

  if (!isProvinceCenterCoord(lat, lng)) return item;

  const fromTitle = provinceCenterFromTitle(item.title);
  if (
    fromTitle &&
    (Math.abs(fromTitle.lat - lat) >= COORD_EPS || Math.abs(fromTitle.lng - lng) >= COORD_EPS)
  ) {
    return { ...item, lat: fromTitle.lat, lng: fromTitle.lng };
  }

  return item;
}

/** Tüm maddeleri düzelt; baskın kümeye yapıştırma yalnızca tekil aykırılar için */
export function normalizeMapItems(items) {
  if (!Array.isArray(items) || items.length === 0) return [];

  const normalized = items.map(normalizeMapItemCoordinates);

  const clusterCounts = new Map();
  for (const item of normalized) {
    const key = `${item.lat},${item.lng}`;
    clusterCounts.set(key, (clusterCounts.get(key) || 0) + 1);
  }

  let dominantKey = null;
  let dominantCount = 0;
  for (const [key, count] of clusterCounts) {
    if (count > dominantCount) {
      dominantCount = count;
      dominantKey = key;
    }
  }

  if (!dominantKey || dominantCount / normalized.length < 0.9) {
    return normalized;
  }

  const [domLat, domLng] = dominantKey.split(',').map(Number);

  return normalized.map((item) => {
    const key = `${item.lat},${item.lng}`;
    const count = clusterCounts.get(key) || 0;
    if (count === 1 && key !== dominantKey && isProvinceCenterCoord(Number(item.lat), Number(item.lng))) {
      return { ...item, lat: domLat, lng: domLng };
    }
    return item;
  });
}
